import calSoftwareForm from './metaData/calSoftwareForm'

export default {
  calSoftwareCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: calSoftwareForm,
      props
    })
  }
}
